<template>
    <div class="right author-right pt0 contract">
        <div class="chapter-title flexible aItem-center jc-between">
            <div class="page-title font-MT ">
                <img class="fh-img" src="@/assets/ic_fh.png" alt="" @click="goBack()">
                <span class="f22 page-name text-333 fwb-600">签约信息</span>
            </div>
        </div>
        <div v-if="(signStatus && signStatus != 0 && !isToAgainSign) " class="header-text">
            <span>签约进程</span>
        </div>
        <div class="steps-wrap" v-if="(signStatus && signStatus != 0 && !isToAgainSign) ">

            <el-steps :active="activeStep" finish-status="success">
                <el-step v-for="(item,index) in progressList" :key="index" :title="item.desc">
                </el-step>
            </el-steps>

        </div>
        <div v-if="(signStatus && signStatus != 0 && !isToAgainSign)">
            <el-table class="table-wrap" :data="tableData" style="width: 100%">
                <el-table-column prop="date" label="审核人" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.editorName }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="操作" align="center">
                    <template slot-scope="scope">
                        <span
                            :style="{color: scope.row.auditDesc == '待签字' ? '#F48E0C': scope.row.pass ?'#0E9A00':'#FF4646'}">
                            {{ scope.row.auditDesc }}</span>

                    </template>
                </el-table-column>
                <el-table-column prop="comment" label="备注 " align="center">
                    <!-- toStatus -->
                    <template slot-scope="scope">
                        <span>{{ scope.row.comment }}</span>
                        <span class="again-sign-btn"
                            v-if="((scope.row.toStatus == -2 || scope.row.toStatus == -3) && (scope.$index + 1) == tableData.length)"
                            @click="againSign">重新签约></span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <el-form v-if="signStatus && (signStatus.code == 0 || signStatus.code == -1|| signStatus.code == -2|| signStatus.code == -3)" ref="form" class="create-form contract-form mt0" :rules="rules" :model="form"> -->
        <el-form v-if="(signStatus != null && signStatus == 0) || isToAgainSign" ref="form"
            class="create-form contract-form mt0" :rules="rules" :model="form">
            <el-form-item label="姓名" prop="name">
                <el-input style="width: 390px;" :disabled="allowEditForm" v-model="form.name" placeholder="请输入您的姓名">
                </el-input>
            </el-form-item>
            <el-form-item label="笔名(签约合同上会显示，请按真实情况填写)" prop="userName">
                <el-input style="width: 390px;" v-model="form.userName" placeholder="请输入您的昵称">
                </el-input>
            </el-form-item>
            <!-- <el-form-item label="手机号" prop="mobile">
                <el-input style="width: 390px;" disabled v-model="form.mobile"  placeholder="请输入您的手机号"></el-input>
            </el-form-item> -->
            <el-form-item label="身份证号" prop="idNo">
                <el-input v-model="form.idNo" :disabled="allowEditForm" placeholder="请输入您的身份证号"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input style="width: 660px;" v-model="form.email" placeholder="请输入您的邮箱">
                </el-input>
                <div class="sms-btn" v-if="isEmailChange == 1" @click="sendEmail()"> 发送验证码</div>
            </el-form-item>
            <el-form-item label="邮箱验证码" prop="emailCode" v-if="isEmailChange == 1">
                <el-input style="width: 660px;" v-model="form.emailCode" placeholder="请输入您的邮箱验证码">
                </el-input>
            </el-form-item>
            <el-form-item label="地址" prop="address">
                <el-input v-model="form.address" placeholder="请输入您的地址">
                </el-input>
            </el-form-item>
            <el-form-item label="开户行信息" prop="bank">
<!--                <div class="f12 text-danger">为了您能收到付款，请详细填写。例如：招商银行 XX省XX市XX县XX支行。仅限于中国大陆银行，要具体到支行，否则无法汇款，不予结算！</div>-->
                <div class="bank-input flex flexible align-center" @click="openbankInfo(2)">
                    <span v-if="form.bank" class="flex ml0">{{form.bank}}</span>
                    <span v-else class="text-muted ml0 f12 flex">请选择您的开户信息</span>
                    <i class="el-icon-arrow-down mr20 mt15"></i>
                </div>
               <!--                <el-input v-model="form.bank" placeholder="请输入您的开户行支行名称">-->
<!--                </el-input>-->
            </el-form-item>
            <el-form-item prop="account" label="银行卡号">
                <el-input v-model.trim="form.account" placeholder="请输入您的银行卡号">
                </el-input>
            </el-form-item>
            <el-form-item label="身份证照片正反面" prop="idFrontImg">
                <div class="flexible sfz-tips">
                    <div class="avatar-uploader">
                        <div class="el-upload el-upload--text">
                            <img class="jia-btn" v-if="!form.idFrontImg" src="@/assets/author/img_add.png">
                            <img class="sfz-img" v-if="form.idFrontImg" :src="form.idFrontImg">
                        </div>
                        <input :disabled="editPhoto" type="file" name="file" @change="uploadFun1"
                            class="el-upload-input" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
                    </div>
                    <div class="avatar-uploader">
                        <div class="el-upload el-upload--text">
                            <img class="jia-btn" v-if="!form.idBackImg" src="@/assets/author/img_add.png">
                            <img class="sfz-img" v-if="form.idBackImg" :src="form.idBackImg">
                        </div>
                        <input :disabled="editPhoto" type="file" name="file" @change="uploadFun2"
                            class="el-upload-input" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
                    </div>
                    <div class="tip-text f14">
                        示例图
                        <div class="tip-imgs ">
                            <div class=" flexible aItem-center jc-between">
                                <img src="@/assets/author/img_sfz1.png">
                                <img src="@/assets/author/img_sfz2.png">
                            </div>
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="手持身份证照片正反面" prop="idHandFrontImg">
                <div class="flexible sfz-tips">
                    <div class="avatar-uploader">
                        <div class="el-upload el-upload--text">
                            <img class="jia-btn" v-if="!form.idHandFrontImg" src="@/assets/author/img_add.png">
                            <img class="sfz-img" v-if="form.idHandFrontImg" :src="form.idHandFrontImg">
                        </div>
                        <input :disabled="editPhoto" type="file" name="file" @change="uploadFun3"
                            class="el-upload-input" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
                    </div>
                    <div class="avatar-uploader">
                        <div class="el-upload el-upload--text">
                            <img class="jia-btn" v-if="!form.idHandBackImg" src="@/assets/author/img_add.png">
                            <img class="sfz-img" v-if="form.idHandBackImg" :src="form.idHandBackImg">
                        </div>
                        <input :disabled="editPhoto" type="file" name="file" @change="uploadFun4"
                            class="el-upload-input" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg">
                    </div>
                    <div class="tip-text f14 " style="left:215px">
                        示例图
                        <div class="tip-imgs ">
                            <div class=" flexible aItem-center jc-between">
                                <img src="@/assets/author/img_sfz3.png">
                                <img src="@/assets/author/img_sfz4.png">
                            </div>

                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item style="text-align: center;">
                <el-button class="f16 creat-btn" @click="saveInfoFun('form')">确定</el-button>
            </el-form-item>
        </el-form>
        <!--开户行信息-->
        <el-dialog
                width="675px"
                :append-to-body="true"
                :lock-scroll="true"
                :center="true"
                class="bank-dialog"
                :visible.sync="bankVisible"
                >


                    <!--录入信息-->

                    <div slot="title" class="dialog-header" style="border-bottom: 1px solid #F3F3F3;">
                         开户行信息
                    </div>

                    <el-form class="bankForm" ref="bankForm" :model="bankForm" :rules="bankFormRules">
                        <el-form-item label="选择银行:" prop="bank" class="mt24">
                            <el-select placeholder="请选择您的开户银行" v-model="bankForm.bank" style="width: 100%">
                                <el-option v-for="i in bankList" :value="i.text" :label="i.text">{{i.text}}</el-option>
                            </el-select>
                        </el-form-item>
                        <div class="flexible">
                            <el-form-item label="选择省、市:" prop="provice">
                                <el-select placeholder="请选择" v-model="bankForm.provice" @change="provincekChange">
                                    <el-option v-for="i in provinceList" :value="i.code" :label="i.text">{{i.text}}</el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label=" " class="ml24 cityInput" prop="city">
                                <el-select placeholder="请选择" v-model="bankForm.city">
                                    <el-option v-for="i in cityList" :value="i.text" :label="i.text">{{i.text}}</el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <el-form-item label="支行名称:" prop="name">
                            <el-input placeholder="请输入您开户行的支行名称" type="textarea" v-model="bankForm.name"></el-input>
                        </el-form-item>
                        <el-form-item class="flexible jc-center">
                            <el-button class="bank-btn" @click="cancel()">取 消</el-button>
                            <el-button class="bank-btn" type="warning" @click="saveShelf()">确 定</el-button>
                        </el-form-item>
                    </el-form>


        </el-dialog>
    </div>
</template>

<script>
    import {
        bookInvitedApi,
        getProgressApi,
        inspectSignApi,
        // writerEditApi,
        emailCheckApi,
        writerImgApi,
        payloggetBank,
        paylogprovince
        // authorlistTargetOrg
    } from "apiurl/author";
    import {
        showLoading,
        hideLoading
    } from "@/utils/load";
    import axios from 'axios';
    import {
        getToken
    } from '@/utils/storage'
    import baseURL from "@/api/env.js";
    import index from '@/mixins/index';
    export default {
        name: "",
        data() {
            var emailRules = (rule, value, callback) => {
                if (this.form.email != this.oldEmail) {
                    this.isEmailChange = 1;
                } else {
                    this.isEmailChange = 2;
                }
                if (!this.form.email) {
                    callback(new Error("请输入正确的邮箱"));
                } else {
                    callback();
                }
            };
            var emailCodeRules = (rule, value, callback) => {

                if (this.isEmailChange != 1) {
                    callback();
                } else if (!this.form.emailCode) {
                    callback(new Error("请输入正确的邮箱验证码"));
                } else {
                    callback();
                }
            };
            var imgRules = (rule, value, callback) => {
                if (!this.form.idFrontImg || !this.form.idBackImg) {
                    callback(new Error("请选择身份证照片正反面"));
                } else {
                    callback();
                }
            };
            var handimgRules = (rule, value, callback) => {
                if (!this.form.idHandFrontImg || !this.form.idHandBackImg) {
                    callback(new Error("请选择手持身份证照片正反面"));
                } else {
                    callback();
                }
            };
            return {
                token: getToken() || null,
                form: {
                    name: '',
                    userName: '',
                    // mobile: '',
                    idNo: '',
                    email: '',
                    emailCode: '',
                    address: '',
                    bank: '',
                    account: '',
                    idFrontImg: '',
                    idFrontImgPath: '',
                    idBackImg: '',
                    idBackImgPath: '',
                    idHandFrontImg: '',
                    idHandFrontImgPath: '',
                    idHandBackImg: '',
                    idHandBackImgPath: '',
                },
                rules: {
                    name: [{
                        required: true,
                        message: "请输入您的姓名",
                        trigger: "blur"
                    }],
                    userName: [{
                        required: true,
                        message: "请输入您的笔名",
                        trigger: "blur"
                    }],
                    // mobile: [{
                    //     required: true,
                    //     message: "请输入您的手机号",
                    //     trigger: "blur"
                    // }],
                    idNo: [{
                        required: true,
                        message: "请输入您的身份证号",
                        trigger: "blur"
                    }],
                    email: [{
                        required: true,
                        validator: emailRules,
                        trigger: "blur"
                    }],
                    emailCode: [{
                        required: true,
                        validator: emailCodeRules,
                        trigger: "blur"
                    }],
                    address: [{
                        required: true,
                        message: "请输入您的地址",
                        trigger: "blur"
                    }],
                    bank: [{
                        required: true,
                        message: "请输入您的开户行支行名称",
                        trigger: "blur"
                    }],
                    account: [{
                        required: true,
                        message: "请输入您的银行卡号",
                        trigger: "blur"
                    }],
                    idFrontImg: [{
                        required: true,
                        validator: imgRules,
                        trigger: "blur"
                    }],
                    idHandFrontImg: [{
                        required: true,
                        validator: handimgRules,
                        trigger: "blur"
                    }],
                },
                uploadIndex: "",
                // countries: [],
                // targetOrgList: [],
                allowEditForm: false, //是否可编辑作者信息
                editPhoto:false,//是否修改身份证图片
                isChange: 2, // 1改变，2没改变
                oldEmail: "", //旧邮箱
                isEmailChange: 2, //邮箱是否改变 1改变，2没改变

                activeStep: 0, //进度
                progressList: [],
                tableData: [],

                // isSign: true,
                signStatus: null, //签约状态
                isToAgainSign: false, //是否点击重新签约
                /*合同*/
                // isShowPop: false,
                // isHuaban: false,
                // signature: '',
                // downimg: '',

                // contractInfo: '',
                // numPages: 1,
                /*开户行*/
                bankVisible: false,
                bankList:[],
                provinceList:[],
                cityList:[],

                bankForm:{
                    bank: '',
                    provice:'',
                    provinceDesc:'',
                    city:'',
                    name:'',
                    account:''
                },
                bankFormRules:{
                    bank: [{
                        required: true,
                        message: "请选择你的开户银行",
                        trigger: ["blur","change"]
                    }],
                    provice: [{
                        required: true,
                        message: "请选择你所属省",
                        trigger: ["blur","change"]
                    }],
                    city: [{
                        required: true,
                        message: "请选择你所属市",
                        trigger: ["blur","change"]
                    }],
                    name: [{
                        required: true,
                        message: "请输入支行名称",
                        trigger: ["blur","change"]
                    }],
                    account: [{
                        required: true,
                        message: "请输入银行卡号",
                        trigger: ["blur","change"]
                    }],
                }
            }
        },
        props: {
            bookdetail: Object
        },
        mounted() {
            this.getbookInvited()
        },
        mixins: [index],
        methods: {
            goBack() {
                // history.back()
                this.$router.push(`/author`);
            },
            /*开户行*/
            openbankInfo (flag) {
                this.bankVisible = true
                payloggetBank().then(res=>{
                    this.bankList = res.data;
                })
                this.getProvinceList()
            },
            getProvinceList(val) {
                let params = {}
                if (val) {
                    params = {code: val}
                }
                paylogprovince(params).then(res=>{
                    if (val) {
                        this.cityList = res.data;
                        this.bankForm.city = ''
                    } else {
                        this.provinceList = res.data;
                    }
                })
            },
            provincekChange(e) {
                this.bankForm.provinceDesc = this.provinceList.filter(item=>{
                    return item.code == e
                })[0].text
                this.getProvinceList(e)
            },
            cancel () {
                // if (!this.form.bank) {
                //     this.bankForm={
                //         bank: '',
                //         provice:'',
                //         provinceDesc:'',
                //         city:'',
                //         name:'',
                //     }
                // }
                this.bankVisible = false

            },
            saveShelf () {
                this.$refs.bankForm.validate((valide)=>{
                    if (valide) {
                        let bank = `${this.bankForm.bank}${this.bankForm.provinceDesc}${this.bankForm.city}${this.bankForm.name}`
                        this.form.bank=bank
                        this.bankVisible = false
                    }

                })
            },
            /*第一步：获取内容*/
            async getbookInvited() {
                let res = await bookInvitedApi(this.$route.params.id)
                if (res.success) {
                    let data = res.data
                    if (!data.edit) {
                        this.allowEditForm = true
                    }
                    this.editPhoto = res.data.editPhoto?false:true
                    this.oldEmail = data.userAuthor.email;
                    this.signStatus = data
                        .signStatus; //code  -3:责编废弃 -2:责编驳回 0:未签约 1:待责编审核 2:签约完成  >0展示进度条 否则展示作者信息
                    // console.log(this.signStatus)
                    if (this.signStatus && this.signStatus != 0) {
                        let params = {
                            bookId: this.$route.params.id
                        }
                        let res1 = await getProgressApi(params)
                        if (res1.success) {
                            this.tableData = res1.data.auditLogs
                            if (res1.data && res1.data.signProgress.length > 0) {
                                this.progressList = res1.data.signProgress;
                                res1.data.signProgress.map((item, index) => {
                                    if (res1.data.signStatus === item.value) {
                                        this.activeStep = index + 1

                                    }
                                })
                            }
                            // this.activeStep = res1.data.signStatus == 0
                            // signProgress
                            console.log(res1.data)
                        }
                    }
                    this.form = {
                        name: data.userAuthor.name,
                        userName: !this.allowEditForm&&data.userAuthor.userName.startsWith('游客')?'':data.userAuthor.userName,
                        userId: data.userAuthor.id,
                        // mobile: data.userAuthor.mobile,
                        idNo: data.userAuthor.idNo,
                        email: data.userAuthor.email,
                        emailCode: data.userAuthor.emailCode,
                        address: data.userAuthor.address,
                        bank: data.userAuthor.bank,
                        account: data.userAuthor.account,
                        // idFrontImg: data.userAuthor.idFrontImgUrl,
                        idFrontImgPath: data.userAuthor.idFrontImg,
                        // idBackImg: data.userAuthor.idBackImgUrl,
                        idBackImgPath: data.userAuthor.idBackImg,
                        // idHandFrontImg: data.userAuthor.idHandFrontImgUrl,
                        idHandFrontImgPath: data.userAuthor.idHandFrontImg,
                        // idHandBackImg: data.userAuthor.idHandBackImgUrl,
                        idHandBackImgPath: data.userAuthor.idHandBackImg,
                    }
                    if (data.userAuthor.idFrontImg) {
                        this.getImg(data.userAuthor.idFrontImg).then(res => {
                            this.form.idFrontImg = res;
                            this.$forceUpdate();
                        })
                    }
                    if (data.userAuthor.idBackImg) {
                        this.getImg(data.userAuthor.idBackImg).then(res => {
                            this.form.idBackImg = res;
                            this.$forceUpdate();
                        })
                    }
                    if (data.userAuthor.idHandFrontImg) {
                        this.getImg(data.userAuthor.idHandFrontImg).then(res => {
                            this.form.idHandFrontImg = res;
                            this.$forceUpdate();
                        })
                    }
                    if (data.userAuthor.idHandBackImg) {
                        this.getImg(data.userAuthor.idHandBackImg).then(res => {
                            this.form.idHandBackImg = res;
                            this.$forceUpdate();
                        })
                    }

                } else {
                    // this.isSign = true
                }
            },
            async getImg(file) {
                let params = {
                    imagePath: file
                }
                const res = await writerImgApi(params);
                if (res.success) {
                    return res.data
                }
            },
            againSign() {
                this.isToAgainSign = true;

            },
            /*****上传图片*********/
            async uploadFun(e, code) {
                if (e.target.files.length == 0) {
                    this.$faild('custom', '请选择要上传的图片')
                    return false
                }
                let file = e.target.files[0];
                // this.form.iconTempFile = window.URL.createObjectURL(e.target.files[0]);
                // 上传图片地址
                this.uploadurl = `${baseURL.AHEAD}/writer/sign/inspect/upload/img`;
                let fileFormData = new FormData();
                fileFormData.append("img", file);
                fileFormData.append("type", this.uploadIndex);
                showLoading()
                const res = await this.uploadImgFun('post', this.uploadurl, fileFormData)
                if (res.success) {
                    hideLoading()
                    return res.data
                } else {
                    hideLoading()
                    this.$faild('operation')
                }
            },
            uploadFun1(e) {
                this.uploadIndex = 1
                this.uploadFun(e).then(res => {
                    this.form.idFrontImg = res.imageUrl
                    this.form.idFrontImgPath = res.imagePath
                    this.$forceUpdate();
                })
            },
            uploadFun2(e) {
                this.uploadIndex = 2
                this.uploadFun(e).then(res => {
                    this.form.idBackImg = res.imageUrl
                    this.form.idBackImgPath = res.imagePath
                    this.$forceUpdate();
                })
            },
            uploadFun3(e) {
                this.uploadIndex = 3
                this.uploadFun(e).then(res => {
                    this.form.idHandFrontImg = res.imageUrl
                    this.form.idHandFrontImgPath = res.imagePath
                    this.$forceUpdate();
                })
            },
            uploadFun4(e) {
                this.uploadIndex = 4
                this.uploadFun(e).then(res => {
                    this.form.idHandBackImg = res.imageUrl
                    this.form.idHandBackImgPath = res.imagePath
                    this.$forceUpdate();
                })
            },
            //邮箱验证
            sendEmail() {
                if (!this.form.email) {
                    this.$faild('custom', '请输入正确的邮箱')
                    return false
                }
                let params = {
                    email: this.form.email
                }
                emailCheckApi(params)
                    .then(res => {
                        if (res.success) {
                            this.$success('custom', '发送成功，请前往邮箱查看验证码')
                        }
                    })
                    .catch(() => {});

            },
            //保存
            saveInfoFun(formName) {

                // this.form.bookId = this.$route.params.id;
                let params = {
                    bookId: this.$route.params.id,
                    name: this.form.name,
                    userName: this.form.userName,
                    idNo: this.form.idNo,
                    email: this.form.email,
                    emailCode: this.form.emailCode,
                    address: this.form.address,
                    bank: this.form.bank,
                    account: this.form.account,
                    idFrontImg: this.form.idFrontImgPath,
                    idBackImg: this.form.idBackImgPath,
                    idHandFrontImg: this.form.idHandFrontImgPath,
                    idHandBackImg: this.form.idHandBackImgPath,
                }

                this.$refs[formName].validate(valid => {
                    if (valid) {
                        showLoading()
                        inspectSignApi(this.qs.stringify(params))
                            // inspectSignApi(this.form)
                            .then(res => {
                                hideLoading()
                                if (res.success) {
                                    this.isToAgainSign = false
                                    this.$success('custom', '提交成功!')
                                    this.getbookInvited()
                                    let infoData = {
                                        name: this.form.userName,
                                        id: this.form.userId,
                                        // iconUrlSmall
                                    }

                                    this.$store.dispatch('saveInfo', infoData)
                                }
                            })
                            .catch(() => {
                                hideLoading()
                            });
                    }
                })
            },
        }
    }
</script>

<style lang="scss">
    .bank-dialog{
        .el-dialog{
            .el-dialog__body,.el-dialog__header{
                padding: 0!important;
            }
            .dialog-header{
                height: 66px;
                border-bottom: 1px solid #F3F3F3;
                line-height: 66px;
                font-size: 16px;
                color: #333;
            }
            .bank-reset{
                padding: 50px 40px 30px;
                .el-icon-warning{
                    color: #F68A01;
                    font-size: 20px;
                }
                .bank-reset-title{
                    font-size: 18px;
                    color: #333;
                    font-weight: 500;
                }
                .bank-reset-con{
                    font-size: 16px;
                    line-height: 30px;
                    color: #333;
                    margin-top: 15px;
                }
                /deep/.reset-btn{
                    margin-top: 10px;
                    background: #F44944;
                    color: #fff;
                    border: none;
                    margin-left: 40px;
                }
                /deep/.reset-cancel-btn{
                    margin-top: 10px;
                    color: #999999!important;
                }
            }
            .bankForm{
                padding: 0 30px 30px;
                .el-form-item__label{
                    float: none;
                    font-size: 16px;
                    color: #333;
                }
                /deep/.el-input__inner,
                /deep/.el-textarea__inner{
                    background-color: #F5F5F5!important;
                    border: 1px solid #ddd!important;
                }

            }
            .cityInput{
                margin-top: 40px;
                .el-form-item__label{
                    display: none;
                }
            }
        }

    }
    .bank-btn{
        width: 140px;
        height: 40px;
        padding: 0;
        line-height: 40px;
        font-size: 18px;
        margin-top: 79px;
        &.el-button--warning{
            background: #F68A01!important;
            color: #fff!important;
            margin-left: 134px;
        }
        &.el-button--primary{
            width: 110px;
        }

    }

</style>
<style lang="scss" scoped>
    @import "@/styles/author.scss";

    .chapter-title {
        padding: 40px 0 !important;
    }

    .contract-img1,
    .contract-finish-img {
        width: 100%;
    }

    .header-text {
        border-bottom: 1px solid #F2F2F2;
        margin-bottom: 10px;

        span {
            margin-bottom: 10px;
            font-size: 16px;
            color: #333;
            font-weight: 500;
            display: inline-block;
        }
    }

    .contract-form {
        // padding-top: 35px;
        padding-bottom: 30px;

        // margin: 0 50px;
        .sfz-tips {
            position: relative;

            .tip-text {
                position: absolute;
                top: -36px;
                left: 150px;
                cursor: pointer;
                color: #A7A7A7;
                background: url('../../../assets/author/ic_tip.png') no-repeat right;
                background-size: 14px 14px;
                padding-right: 20px;

                .tip-imgs {
                    position: absolute;
                    // top: -30px;
                    left: 50px;
                    display: none;
                    width: 772px;
                    height: 311px;
                    background: #FFFFFF;
                    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.1);
                    padding: 0 45px;
                    box-sizing: border-box;
                    z-index: 9;

                    &>div {
                        height: 100%;
                    }

                    img {
                        display: inline-block;
                        width: 331px;
                        height: 191px;
                    }
                }
            }

            .tip-text:hover {
                color: #F68A01 !important;
                background: url('../../../assets/author/ic_tip1.png') no-repeat right;
                background-size: 14px 14px;

                .tip-imgs {
                    display: block;
                }
            }
        }

        .avatar-uploader {
            width: 331px;
            height: 191px;
        }

        .avatar-uploader {
            position: relative;
            background: #F5F5F5;
            border-radius: 4px;
            margin-right: 20px;

            .el-upload {
                width: 331px;
                height: 191px;

                .jia-btn {
                    width: 65px;
                    height: 65px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    margin-left: -32px;
                    margin-top: -32px;
                }

                .sfz-img {
                    width: 100%;
                    height: 100%
                }
            }
        }

        .avatar-uploader .el-upload-input {
            width: 331px;
            height: 191px;
        }

        .sms-btn {
            position: absolute;
            top: 3px;
            left: 575px;
            color: #F68A01;
            cursor: pointer;
        }
    }
    .bank-input{
        height: 40px;
        line-height: 40px;
        background: #F5F5F5;
    }
    .contract {

        /deep/.chapter-tip-btn,
        .down-contract {
            margin-left: 30px;
        }

        .upload-btn-info,
        .upload-btn-info .el-upload,
        .upload-btn-info .el-upload-input,
        .upload-btn-info .el-button {
            width: 230px;
            height: 42px;
        }

        /deep/.chapter-tip-btn {
            margin-top: 30px;
            padding-bottom: 50px;
        }

        /deep/.contract-dialog {
            /deep/.surepop {
                width: 566px;
                height: 441px;
                background-size: 566px 441px;
            }
        }
    }

    .contract-warp {
        position: absolute;
        width: 600px;
        height: 450px;
        overflow: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);

        .contract-down-btn {
            position: absolute;
            height: 78px;
            width: 100%;
            bottom: 0;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 10px;

            /deep/.el-button--medium {
                width: 160px;
            }
        }

        .huaban-con {
            width: 100%;
            height: 100%;
            position: relative;

            /deep/.composeImg-btn {
                margin-right: 30px;
            }

            /deep/.board-box {
                left: 50%;
                transform: translateX(-50%);
                top: 50px;
            }

            .view-btn {
                text-decoration: underline;
                position: absolute;
                left: 80px;
                bottom: 35px;
                color: #48A2DF;
            }
        }

        @media (max-width:768px) {
            .close {
                margin-right: 130px !important;
            }

            /*width:100%!important;*/
        }
    }

    .steps-wrap {
        height: 110px;
        background: #FBFBFB;
        border-radius: 4px;
        box-sizing: border-box;
        padding-top: 50px;

        /deep/.el-steps {
            justify-content: center;
        }

        /deep/.el-step {
            // width: 100px !important;
            flex-basis: 145px !important;
            text-align: right !important;
        }

        /deep/.el-step__main {
            position: relative;
        }

        /deep/.el-step__title {
            position: absolute !important;
            top: -50px;
            left: 95px;
            width: 100px;
            font-size: 14px;
            color: #ccc;
            font-weight: 400;
            text-align: center;
        }

        /deep/.el-step__line-inner {
            border: none;
        }

        /deep/.el-step__title.is-success {
            color: #F48E0C !important;
        }

        // /deep/.el-step__description {
        //     position: absolute !important;
        //     top: 30px;
        //     left: 125px;
        //     width: 100px;
        //     font-size: 14px;
        //     width: 100px;
        //     height: 28px;
        //     line-height: 28px;
        //     text-align: center;
        //     // background: #CCCCCC;
        //     border-radius: 20px;
        //     padding-right: 0;
        // }

        /deep/.el-step__description.is-process,
        /deep/.el-step__description.is-wait {
            background: #CCCCCC !important;
            color: #fff;
        }

        // /deep/.el-step__description.is-success {
        //     background: #F48E0C;
        //     color: #fff;
        // }

        /deep/.el-step:last-of-type .el-step__line {
            display: block !important;
        }

        /deep/.el-step:last-of-type {
            width: 290px !important;
            flex-basis: 290px !important;
            text-align: center !important;
            max-width: 290px !important;
        }

        /deep/.el-step__head .el-step__line {
            height: 0;
            background: transparent;
            border: 1px dashed #C0C4CC;
            top: 7px;
        }

        /deep/.is-process .el-step__line {
            border: 1px dashed #C0C4CC;
        }

        /deep/.el-step__head.is-success {
            color: #F48E0C;
            border-color: #F48E0C;
        }

        /deep/.is-success .el-step__line {
            border: 1px dashed #F48E0C !important;

        }

        /deep/.el-step__icon-inner {
            display: none;
        }

        /deep/.el-step__head .el-step__icon {
            width: 8px;
            height: 8px;
            background: #CCCCCC;
            border: none;
        }

        /deep/.el-step__head.is-success .el-step__icon {
            background: #F48E0C !important;
        }


    }

    .table-wrap {
        border-radius: 4px !important;
        border: 1px solid #CCCCCC !important;
        margin-top: 20px;

        /deep/th {
            text-align: center;
            background: #EDEDED;
        }

        /deep/tr {
            background-color: #FBFBFB;
        }

        /deep/tr:hover td {
            background-color: #FBFBFB;
        }
    }

    .again-sign-btn {
        color: #F69112;
        cursor: pointer;
        padding-left: 20px;
    }
</style>
<style lang="scss">
    .contract-pop {
        background: rgba(0, 0, 0, 0.8) !important;
        color: #fff;
        font-size: 16px !important;
        font-family: Arial !important;
        line-height: 26px !important;
        border-radius: BLACKCRAG !important;

        .popper__arrow,
        .popper__arrow::after {
            border-top-color: #000 !important;
        }

    }
</style>
